import React, { useEffect, useState, useContext } from 'react'
import styled from 'styled-components'

// components
import ShopInfo from '../../components/storeInfo/ShopInfo'
import Loading from '../../components/atom/loading/Loading'
import { HeaderTab } from '../../components'

// globals
import * as constants from '../../globals/constants'
import * as TYPE from '../../globals/type'
import StoreContext from '../../globals/StoreContext'

// constants
const STORE_HEADER_ITEM = ['기본정보', '운영정보', '배달정보']
const STORE_HEADER_ITEM_N = ['기본정보', '운영정보']

const StoreList = () => {
  const user = JSON.parse(localStorage.getItem('user'))
  const [hiddenYn, setHiddenYn] = useState(null) // 배달정보 숨김처리

  //매장 정보 조회 및 초기 매장정보
  const contextData = useContext(StoreContext)
  const { storeInfoData, getStoreInfo } = contextData || {}

  //로딩
  const setLoading = storeInfoData ? 'true' : 'false'

  //매장정보 초기Init
  useEffect(() => {
    if (storeInfoData) {
      setHiddenYn(storeInfoData.responseData?.hiddenMenuEnableYn)
    }
  }, [storeInfoData])

  return (
    <>
      {!setLoading ? (
        <Loading />
      ) : (
        <>
          {hiddenYn === 'N' ? (
            <HeaderTab
              isDesktop={true}
              headerItem={STORE_HEADER_ITEM_N}
              headerLinks={['/storeList', '/manageStoreInfo']}
              selectedItem={0}
            />
          ) : (
            <HeaderTab
              isDesktop={true}
              headerItem={STORE_HEADER_ITEM}
              headerLinks={[
                '/storeList',
                '/manageStoreInfo',
                '/storeDeliveryInfo',
              ]}
              selectedItem={0}
            />
          )}

          <Container>
            <ShopInfo
              data={storeInfoData?.responseData?.storeInfo}
              logo={
                user
                  ? `${constants.IMG_URL}${user.brandImg}?version=${constants.BRAND_IMG_VERSION}`
                  : null
              }
            />
          </Container>
        </>
      )}
    </>
  )
}

export default StoreList

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  position: relative;

  @media ${(props) => props.theme.mobile} {
    padding: 0 20px;
  }
`
